module.exports = __webpack_public_path__ + "img/shili.91535df3.jpg";